










































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { filterEmpty } from '@acgn/herm/src/util/business';
import { getDateTimeStamp, setDateTimeStamp } from '@acgn/herm/src/util/time';
import { AttributeMixin } from '@/mixins';
import { SearchMixin } from '@acgn/herm/src/mixins';
import { AcgnTargetEdit, AcgnPriceEdit } from '@/components';

import {
  AcgnSearchWrap,
  AcgnTable,
  AcgnTableButtonGroup,
  AcgnTopButton,
  AcgnPermission
} from '@acgn/herm/src/ui';
import { displayFormValidationError } from '@acgn/herm/src/util/form';
import event from '@acgn/herm/src/util/event';

const StaffAction = namespace('desk/staff').Action;
const ComicAction = namespace('desk/comic').Action;

const StaffGetter = namespace('desk/staff').Getter;
const ComicGetter = namespace('desk/comic').Getter;

interface SearchType { // 项目搜索字段
  project_id?: number | null; // 漫画id
  project_name?: string; // 漫画名称
  user_name?: string; // 员工名称
  page?: number; // 当前页码
}

interface PopTargetData { // 弹窗
  visible: boolean; // 是否显示
  data: any; // 弹窗交互数据
}

// 组件申明
@Component({
  components: {
    AcgnSearchWrap,
    AcgnTable,
    AcgnTopButton,
    AcgnTargetEdit,
    AcgnPriceEdit
  },
  mixins: [AttributeMixin, SearchMixin]
})
export default class StaffList extends Vue {

  @StaffAction private getTargetStaffList: any; // 获取员工列表
  @ComicAction private getProjectListByName: any; // 根据关键词获取漫画项目列表(模糊搜索))

  @StaffGetter private targetStaffList: any; // 员工列表
  @StaffGetter private loadings: any; // 员工loading

  private searchForm: SearchType = { // 头部筛选项
    project_id: null,
    project_name: '',
    user_name: '',
    page: 1
  };

  private comics: any = [];

  private targetData: PopTargetData = {  // 弹窗
    visible: false,
    data: null
  };
  private priceData: PopTargetData = {  // 价格弹窗
    visible: false,
    data: null
  };

  private pageConfig: any = { // 分页数据
    total: 0,
    currentPage: 1
  };

  private selectRows: any = [];

  // 列表配置
  private tableConfig1: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        label: '员工姓名',
        prop: 'user_name'
      },
      {
        label: '所属部门',
        prop: 'depart',
        render: (h: any, { row }: any) => `${row.user_depts.map((item: any) => item.dept_name).join(',')}`
      },
      {
        minWidth: 100,
        label: '单价',
        prop: 'unit_price',
        render: (h: any, { row }: any) => (this as any).renderPrice(row)
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: 'ift-chapter',
              color: '#73c800',
              text: row.unit_price ? '修改单价' : '设定单价',
              type: 'price',
              disabled: false,
              permission: [row.unit_price ? '2006' : '2005'],
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

   private tableConfig2: any = {
    rowClassName: ({ row }: any) => {
      return `page-table-row ${row.state === 2 ? 'color--danger' : ''}`;
    },
    columns: [
      {
        type: 'selection',
        width: 48,
        prop: 'user_id'
      },
      {
        label: '员工姓名',
        prop: 'user_name'
      },
      {
        label: '所属部门',
        prop: 'depart',
        render: (h: any, { row }: any) => `${row.user_depts.map((item: any) => item.dept_name).join(',')}`
      },
      {
        minWidth: 100,
        label: '目标进度',
        prop: 'target_num',
        render: (h: any, { row }: any) => (this as any).renderTarget(row)
      },
      {
        minWidth: 100,
        label: '单价',
        prop: 'unit_price',
        render: (h: any, { row }: any) => (this as any).renderPrice(row)
      },
      {
        label: '操作',
        prop: 'action',
        minWidth: 100,
        fixed: 'right',
        showOverflowTooltip: false,
        render: (h: any, { row, $index }: any) => {
          const btns = [
            {
              icon: 'ift-chapter',
              color: '#73c800',
              text: row.target_num ? '修改目标' : '设定目标',
              type: 'edit',
              disabled: false,
              permission: [row.target_num ? '2004' : '2003'],
            },
            {
              icon: 'ift-chapter',
              color: '#73c800',
              text: row.unit_price ? '修改单价' : '设定单价',
              type: 'price',
              disabled: false,
              permission: [row.unit_price ? '2006' : '2005'],
            }
          ];
          btns.forEach((btn: any) => {
            btn.row = row;
          });
          return h(AcgnTableButtonGroup, {
            props: {
              btns,
            },
            on: {
              click: (item: any) => {
                this.onListAction(item);
              },
            },
          });
        }
      }
    ],
    data: []
  };

  private tableConfig: any = this.tableConfig1;
  private get isCanSetTartget() {
    if (this.selectRows.length === 0) {
      return false;
    }
    return this.selectRows.every((item: any) => item.schedule.target_num === 0);
  }

  private get isCanEditTartget() {
    if (this.selectRows.length === 0) {
      return false;
    }

    // 如果不全是已设定目标的，不允许
    const re = this.selectRows.every((item: any) => item.schedule.target_num > 0);
    if (!re) {
      return false;
    }

    let filterObj: any = {};
    // 如果周期不一致，不允许修改
    this.selectRows.map((item: any) => {
      filterObj[item.schedule.target_period] = 1;
    });
    if (Object.keys(filterObj).length > 1) {
      return false;
    }

    // 如果环节不一致，也不允许修改
    filterObj = {};
    this.selectRows.map((item: any) => {
      filterObj[item.schedule.target_type] = 1;
    });
    if (Object.keys(filterObj).length > 1) {
      return false;
    }

    return true;
  }

  private async created() {
    const cacheForm: any = this.$getFormCache();
    let project_id: any = (this as any).$route.params.project_id;
    if (project_id) {
      project_id = project_id - 0;
    }
    this.searchForm = { ...this.searchForm, project_id, ...cacheForm };
    if (this.searchForm.page) { // 如果有缓存页码，先赋值
      this.pageConfig.currentPage = this.searchForm.page;
    }
    await this.remoteComicList();
  }

  // 漫画加载
  private async remoteComicList() {
    const { result } = await this.getProjectListByName();
    this.comics = result;
    if (!this.searchForm.project_id && this.comics.length > 0) {
      // this.searchForm.project_id = this.comics[0].id;
    }
    // this.search();
  }

  // 列表操作项
  private onListAction(item: any) {
    const row = item.row;
    switch (item.type) {
      case 'edit':
        const rowData = row.schedule;
        const type = rowData.target_num ? 4 : 3;
        const data = {
          period: rowData.period,
          project_id: this.searchForm.project_id,
          target_period: type === 4 ? rowData.target_period : null,
          target_type: type === 4 ? rowData.target_type : null,
          target_num: type === 4 ? rowData.target_num : null,
          user_id: [row.user_id]
        };
        this.doEdit(data, type);
        break;
      case 'price':
         const data2 = {
          user_id: [row.user_id],
          unit_price: row.unit_price
        };
        this.doPriceEdit(data2, data2.unit_price <= 0 ? 1 : 2);
        break;
    }
  }

  private editCli(type: number) {
    const rowData = this.selectRows[0].schedule;
    const data = {
      period: rowData.period,
      project_id: this.searchForm.project_id,
      target_period: type === 2 ? rowData.target_period : null,
      target_type: type === 2 ? rowData.target_type : null,
      target_num: type === 2 ? rowData.target_num : null,
      user_id: this.selectRows.map((item: any) => item.user_id)
    };
    this.doEdit(data, type);
  }

  private doEdit(data: any, type: number = 1) {
    this.targetData.data = {
      type,
      data
    };
    this.targetData.visible = true;
  }
  private doPriceEdit(data: any, type: number = 1) {
    this.priceData.data = {
      type,
      data
    };
    this.priceData.visible = true;
  }

 private renderPrice(row: any) {
    const info = row.unit_price === 0 ? '未设定单价' :
      `${row.unit_price}`;
    return (
      <span>{`${info}`}</span>
    );
  }

  private renderTarget(row: any) {
    const schedule = row.schedule;
    const info = schedule.target_num === 0 ? '未设定目标' :
      `${schedule.target_type === 1 ? '环节数' : '件数'}:
     ${schedule.finish_num}/${schedule.target_num}`;
    return (
      <span>{`${schedule.period}${info}`}</span>
    );
  }

  // 刷新当前页
  private reloadList() {
    this.initSearh({ page: this.pageConfig.currentPage });
  }

  // 搜索
  private search() {
    this.initSearh({ page: 1 });
  }

  // table组件获取数据更新数据接口
  private async initSearh({ page }: { page: any }) {
    if (!this.searchForm.project_id) {
       this.tableConfig = this.tableConfig1;
    } else {
       this.tableConfig = this.tableConfig2;
    }
    const { tableConfig, pageConfig } = this;
    const options = {
      ...filterEmpty(this.searchForm),
      page,
      size: 30
    };
    await this.getTargetStaffList(options);
    const { result, paging } = this.targetStaffList;
    tableConfig.data = result.list;
    pageConfig.currentPage = paging.page;
    pageConfig.pageSize = paging.size;
    pageConfig.total = paging.total;

    const { page_size, ...args } = options;
    this.$setFormCache({ ...args });
  }

  private handleSelectionChange(val: object[]) {
    this.selectRows = val;
  }
  private selectProjectChange() {
    this.search();
  }

}
